<template>
  <div class="program">
    <div class="title">
      <p>智慧地产生态链架构图</p>
      <div class="line"></div>
    </div>
    <div class="desc">
      <p>
        建造业务一体化ERP平台由前台项目管理系统与渠道风控系统，中台渠道管理系统与人员管理系统，后台财务一体化构成，三者之间实现“架构可互操作、数据融合一体、流程线上贯通”，组成一体化的智慧地产生态链解决方案。
      </p>
    </div>
    <div class="img-box">
      <img src="../../static/images/product/biaodan.png" />
    </div>
    <div class="title mar">
      <p>智慧地产生态链解决方案</p>
      <div class="line"></div>
    </div>

    <div class="resolve-tabs">
      <div class="tab-left">
        <div
          class="left-item"
          :class="{ active: fristSelect == item.id }"
          v-for="(item, index) in tabsObj.leftList"
          :key="item.id"
          @click="changeTabs(item.id, 'left', index)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="separate-left"></div>

      <div class="tab-right">
        <div
          class="tab-top"
          v-for="item in tabsObj.topList"
          :key="item.select"
          v-show="item.select == fristSelect"
        >
          <div
            class="top-item"
            v-for="s_item in item.list"
            :key="s_item.id"
            :class="{ active: secondSelect == s_item.id }"
            @click="changeTabs(s_item.id, 'top')"
          >
            {{ s_item.title }}
          </div>
        </div>
        <div class="spread-top"></div>
        <div
          class="tab-content"
          v-for="item in tabsObj.contentList"
          :key="item.id"
          v-show="allSelect == item.id"
        >
          <div class="aim">
            {{ item.aim }}
          </div>
          <div class="more-btn" @click="jumpPages(item.id)">了解更多</div>

          <div class="adv m_flex" v-if="item.adv && item.adv.name">
            <div class="content-title">{{ item.adv.name }}</div>
            <div class="adv-right">
              <div
                class="content-item m_flex"
                v-for="(s_item, s_index) in item.adv.list"
                :key="s_index"
              >
                <img :src="s_item.img" />
                <p>{{ s_item.desc }}</p>
              </div>
            </div>
          </div>
          <div class="feature m_flex">
            <div class="content-title">{{ item.fea.name }}</div>
            <div class="feature-right">
              <div
                class="feature-item"
                v-for="(s_item, s_index) in item.fea.list"
                :key="s_index"
                :class="{
                  'big-width': item.id == 'mark-transantion',
                  'middle-width':
                    item.id == 'mark-sell' || item.id == 'opera-hall',
                }"
              >
                <img :src="s_item.img" />

                <div class="ct-box">
                  <h2>{{ s_item.title }}</h2>
                  <p>{{ s_item.desc }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="adv m_flex" v-if="item.fun && item.fun.name">
            <div class="content-title">{{ item.fun.name }}</div>
            <div class="adv-right">
              <div
                class="content-item m_flex"
                v-for="(s_item, s_index) in item.fun.list"
                :key="s_index"
              >
                <img :src="s_item.img" />
                <p>{{ s_item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabsObj: {
        leftList: [
          { id: "mark", title: "智慧营销体系" },
          { id: "life", title: "智慧生活体系" },
          { id: "opera", title: "智慧经营体系" },
        ],
        topList: [
          {
            select: "mark",
            list: [
              { id: "spread", title: "智慧传播" },
              { id: "channel", title: "智慧渠道" },
              { id: "case", title: "智慧案场" },
              { id: "sell", title: "智慧行销" },
              { id: "transantion", title: "智慧交易" },
            ],
          },
          {
            select: "opera",
            list: [{ id: "hall", title: "智慧售楼系统" }],
          },
        ],
        contentList: [
          {
            id: "mark-spread",
            aim: "以移动设备作为展示平台，在手机、平板电脑等移动端进行展示的房产销售产品,扩大了营销渠道，疏通行业信息传播渠道，加强用户体验。",
            adv: {
              name: "优势",
              list: [
                {
                  img: require("../../static/images/product/dot.png"),
                  desc: "完整还原地产产品减少成本、减少时间",
                },
                {
                  img: require("../../static/images/product/dot.png"),
                  desc: "弥补纸质展示的不足提高后期回访和转化",
                },
                {
                  img: require("../../static/images/product/dot.png"),
                  desc: "线上看房留联提升转为成单用户机率",
                },
              ],
            },
            fea: {
              name: "功能",
              list: [
                {
                  img: require("../../static/images/product/book_tab.png"),
                  title: "微楼书",
                  desc: "展示楼盘单价、信息、特色、周边配套等详情",
                },
                {
                  img: require("../../static/images/product/zixun_tab.png"),
                  title: "在线咨询",
                  desc: "IM即时聊天，告别电话销售的尴尬",
                },
                {
                  img: require("../../static/images/product/youhui_tab.png"),
                  title: "优惠活动",
                  desc: "玩转线上营销",
                },
                {
                  img: require("../../static/images/product/kehu_tab.png"),
                  title: "推荐客户",
                  desc: "拉新引流，一站式全民营销",
                },
                {
                  img: require("../../static/images/product/jifen_tab.png"),
                  title: "积分商城",
                  desc: "社区运营，提高用户粘性",
                },
                {
                  img: require("../../static/images/product/goufang_tab.png"),
                  title: "线上购房",
                  desc: "专业保障，促进成单",
                },
              ],
            },
          },
          {
            id: "mark-channel",
            aim: "人脸识别判客规则和百度人脸识别技术有效结合，实现智能判断客户到访时间与渠道推荐时间的先后，得出是否飞单、洗客、截客结论。大大降低内单外飞风险和营销费用，以及后期人工核查成本！",
            fea: {
              name: "特点",
              list: [
                {
                  img: require("../../static/images/product/zhineng_tab.png"),
                  title: "智能化数据采集",
                  desc: "以线下人脸数据为基础，对客流统计、属性统计、轨迹统计进行采集",
                },
                {
                  img: require("../../static/images/product/duowei_tab.png"),
                  title: "多维数据整合",
                  desc: "以购房客户为核心，打通融合各类系统数据",
                },
                {
                  img: require("../../static/images/product/ai_tab.png"),
                  title: "AI智能分析",
                  desc: "用户画像（客户标签化、画像模型）",
                },
                {
                  img: require("../../static/images/product/quanmian_tab.png"),
                  title: "全面提高案场核心价值",
                  desc: "推进由业务处理型向营销服务型转变，提升营销，营销氛围营造",
                },
                {
                  img: require("../../static/images/product/renlian_tab.png"),
                  title: "新型人脸识别技术",
                  desc: "增强用户体验度：人脸识别、无感判断",
                },
              ],
            },
          },
          {
            id: "mark-case",
            aim: "让房地产销售跳脱传统模式，不再受制于工程进度，将项目通过3D的方式提前呈现，前置蓄客，缩短营销去化周期； 营销不再局限于线下售楼部，置业顾问更方便外出拓客；配合线上传播，客户不受约束、随时随地看房，让售楼更加立体，帮助项目快速去化。",
            fea: {
              name: "功能",
              list: [
                {
                  img: require("../../static/images/product/dianzi_tab.png"),
                  title: "电子楼书",
                  desc: "品牌楼书，图文展示",
                },
                {
                  img: require("../../static/images/product/jiaotong_tab.png"),
                  title: "区位交通",
                  desc: "从宏观到微观，介绍项目区位优势，展示项目周边配套",
                },
                {
                  img: require("../../static/images/product/sanwei_tab.png"),
                  title: "三维沙盘",
                  desc: "三维软件虚拟建模，日照变化、四季变化，惊艳还原项目周边建筑与场景",
                },
                {
                  img: require("../../static/images/product/quanjing_tab.png"),
                  title: "全景样板间",
                  desc: "多角度观赏样板间，跳转 或行走方式切换场景",
                },
                {
                  img: require("../../static/images/product/yuanlin_tab.png"),
                  title: "园林漫游",
                  desc: "体验园林景观和商业氛围，如同身临其境",
                },
                {
                  img: require("../../static/images/product/sass_tab.png"),
                  title: "知屋SaaS系统",
                  desc: "集客户画像，浏览追溯，销售管理于一体，提供可量化的项目营销依据",
                },
                {
                  img: require("../../static/images/product/huxing_tab.png"),
                  title: "户型鉴赏",
                  desc: "在沙盘上清晰展示户型落位，直观展示户型位置结构、布局风格",
                },
                {
                  img: require("../../static/images/product/xiaoshou_tab.png"),
                  title: "销售工具",
                  desc: "内置画笔，录屏，房贷计算，置业计划等销售常用小工具",
                },
              ],
            },
          },
          {
            id: "mark-sell",
            aim: "智能生活平台可以自由的与主流智能家居品牌产品互通，任何时候，任何场合，家庭用户可以自由的通过无线链接Internet，直接上互联网远程查询到相关所需信息并具备社交互动特点。",
            fea: {
              name: "优势",
              list: [
                {
                  img: require("../../static/images/product/jiejie_tab.png"),
                  title: "营销链节节打通 全民皆是营销客",
                  desc: "借助微信平台，让营销链条上的业主、粉丝、员工、二手经纪人等群体全部打通，破除以往销售角色单一的局限，每个人都可注册成为楼盘的经纪人，强力拓宽营销渠道。",
                },
                {
                  img: require("../../static/images/product/fanyong_tab.png"),
                  title: "返佣政策强力驱动 激励销售热情",
                  desc: "通过“返佣”模式的激励与调动，使用户自发地投身经纪人行列，避免传统佣金低、环节多导致的经纪人热情衰减局限，全面激励人员销售热情，获得最大化收益。",
                },
                {
                  img: require("../../static/images/product/jieshi_tab.png"),
                  title: "借势新媒体传播 精准投放控制成本",
                  desc: "借助微信传播优势，打破传统渠道费用昂贵且收效不佳的局面产生“自媒体效应”，让楼盘信息在用户间主动流动，达到资源的最大优化配置，实现价值传播和成本控制的“双丰收”。",
                },
              ],
            },
            fun: {
              name: "功能",
              list: [
                {
                  img: require("../../static/images/product/weilou_tab.png"),
                  desc: "微楼书",
                },
                {
                  img: require("../../static/images/product/quanmin_tab.png"),
                  desc: "全民分享",
                },
                {
                  img: require("../../static/images/product/tuijian_tab.png"),
                  desc: "全民推荐",
                },
                {
                  img: require("../../static/images/product/fenyong_tab.png"),
                  desc: "分佣激励",
                },
              ],
            },
          },
          {
            id: "mark-transantion",
            aim: "从数据本源出发，才可以了解数据中蕴含的规律，才可以真正研究数据；为交易安全保驾护航。",
            fea: {
              name: "优势",
              list: [
                {
                  img: require("../../static/images/product/yanzi_tab.png"),
                  title: "验资锁客：意向客户筛选和高效合规锁客",
                  desc: "交易环节监管越来越严，禁止任何形式的收筹。使用验资锁客，无证可合规验资并冻结客户资金，有证可快速收取认筹金，开盘时一键转定，开盘后一键原路退款，提高解冻和退筹效率，实现对意向客户筛选和锁定。",
                },
                {
                  img: require("../../static/images/product/jizhong_tab.png"),
                  title: "集中开盘：无缝对接摇号开盘，转化飙升",
                  desc: "最近，以成都为代表的7大城市实行了摇号选房，针对摇号选房我们研发了线下智能开盘产品，高效配合政府产出客户摇号结果，实现无缝对接摇号选房。",
                },
                {
                  img: require("../../static/images/product/qianyue_tab.png"),
                  title: "签约&按揭：构建开发商、政府、银行生态链接",
                  desc: "在签约&按揭服务环节，我们将整合政府、银行资源，实现签约&按揭业务全流程在线化，让客户少跑腿，共同优化购房全流程效率，降低客户成本，改善客户购房体验。",
                },
              ],
            },
          },
          {
            id: "opera-hall",
            aim: "多年地产深耕，依托行业实践及前沿技术，一匠云自主研发数字化创新方案与产品，提供企业级云ERP整体解决方案。 聚焦数据和技术优势，赋能房企智能化运营和数字化创新能力，打通信息孤岛、连接碎片场景、提升管理效能，实现房企业务规模和商业模式的突破。",
            fea: {
              name: "特点",
              list: [
                {
                  img: require("../../static/images/product/huoke_tab.png"),
                  title: "在线获客",
                  desc: "从依赖电话和面对面交流的线下业务办理，变革为营销获客在线，销售互动在线，沟通业务在线的客户在线过程",
                },
                {
                  img: require("../../static/images/product/caiji_tab.png"),
                  title: "采集数字化",
                  desc: "从无聊沙盘、印刷物料、手工登记的传统案场，变革为智能硬件应用，内容数字化，触点自动采集的数字案场",
                },
                {
                  img: require("../../static/images/product/guankong_tab.png"),
                  title: "管控数据自动化",
                  desc: "从线下协作，表单统计，变革为销售过程移动化、业务协作在线化、案场管控数据化、销售流程自动化",
                },
                {
                  img: require("../../static/images/product/dwgk_tab.png"),
                  title: "多维管控",
                  desc: "从仅关注业绩结果，数据统计滞后的传统业绩管理模式，变革为实时数据，多维管控，在线决策的营销在线管控",
                },
              ],
            },
          },
        ],
      },
      fristSelect: "mark",
      secondSelect: "spread",
      allSelect: "mark-spread",
      leftIndex: 0,
    };
  },
  methods: {
    jumpPages(str) {
      let type = str.split("-")[1];

      if (type == "spread" || type == "case" || type == "channel") {
        this.$router.push("/wisdomMarket/" + type);
      } else {
        this.$addConsult()
      }
    },
    changeTabs(id, type, index) {
      if (type == "left") {
        this.fristSelect = id;
        if (this.leftIndex != index) {
          switch (index) {
            case 0:
              this.secondSelect = "spread";
              break;
            case 2:
              this.secondSelect = "hall";
              break;
          }
          this.leftIndex = index;
        }
        this.allSelect = id + "-" + this.secondSelect;
      } else if (type == "top") {
        this.secondSelect = id;
        this.allSelect = this.fristSelect + "-" + id;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.program {
  width: 100%;
  height: 1800px;
  background: url('../../static/images/product/bg.png') no-repeat;
  padding-top: 90px;

  .title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
      font-size: 30px;
      font-weight: bold;
      color: #F9FBFF;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }
  }

  .title.mar {
    margin-top: 60px;
    margin-bottom: 30px;
  }

  .desc {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 46px 0 39px;

    p {
      width: 987px;
      font-size: 16px;
      font-weight: 500;
      color: #EBEBEB;
      line-height: 30px;
    }
  }

  .img-box {
    width: 1462px;
    height: 821px;
    background: #FFFFFF;
    border-radius: 4px;
    margin: 0 auto;
    text-align: center;
    box-sizing: border-box;
    padding-top: 57px;
  }

  .resolve-tabs {
    display: flex;
    justify-content: center;

    .left-item.active {
      border-left: 2px solid #FFC000;
    }

    .tab-right {
      min-width: 1210px;
    }

    .top-item.active {
      border-bottom: 3px solid #FFC000;
    }

    .tab-top {
      display: flex;
      margin: 28px 0 0 32px;
    }

    .left-item, .top-item {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #BFBFBF;
      cursor: pointer;
    }

    .active {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #FFFFFF;
    }

    .left-item {
      padding: 0 21px 0 14px;
      margin-top: 38px;
    }

    .top-item {
      display: flex;
      padding: 0 28px 17px 29px;
    }

    .separate-left {
      width: 1px;
      height: 393px;
      background: #585858;
    }

    .spread-top {
      width: 1005px;
      height: 1px;
      background: #585858;
      margin-left: 32px;
    }

    .tab-content {
      position: relative;
      margin: 25px 0 0 60px;

      .more-btn {
        position: absolute;
        top: -10px;
        right: 220px;
        width: 107px;
        height: 40px;
        background: #EDB50B;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }

      .aim {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #BFBFBF;
        width: 734px;
        line-height: 18px;
        margin-bottom: 31px;
      }

      .m_flex {
        display: flex;
        flex-wrap: wrap;
      }

      .adv {
        .adv-right {
          display: flex;
          flex-wrap: wrap;
          width: 800px;
        }
      }

      .content-title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #E5E5E5;
        margin-right: 42px;
      }

      .content-item {
        align-items: center;
        margin: 0 56px 23px 0;

        p {
          height: 16px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          margin-left: 6px;
        }
      }

      .feature-right {
        display: flex;
        align-items: center;
        width: 1080px;
        flex-wrap: wrap;
      }

      .feature-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 23px;
        padding-right: 50px;
        box-sizing: border-box;
        width: 33.33%;

        .ct-box {
          margin-left: 8px;

          h2 {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #FFFFFF;
            margin-bottom: 17px;
          }

          p {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #BFBFBF;
            line-height: 20px;
            margin-left: 0;
          }
        }

        img {
          min-width: 18px;
          min-height: 18px;
          margin-top: 8px;
        }
      }

      .big-width {
        width: 80%;
      }

      .middle-width {
        width: 40%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/ProductProgram.vue